import {
    ADD_ROLE,
    GET_ROLE,
    ALL_ROLE,
    EDIT_ROLE,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const addRole = (state = initialState, action) => {
    switch (action.type) {
      case ADD_ROLE:
        return  state = {
          ...state,
          loading: true,
        }
        case GET_ROLE:
          return  state = {
          ...state,
          loading: true,
        }
        case ALL_ROLE:
          return   state = {
              ...state,
              loading: false,
              data:action.payload.data
            }
        case EDIT_ROLE:
          return  state = {
            ...state,
            loading: false,
            data:action.payload.data
          }
        default: 
        return state
    }
  }

 

  export  default addRole
  